<main class="cart-container">


  <!-- =====================================================
       HEADER
       ===================================================== -->

  <div class="cart-header">

    <div>

      <span class="cart-label">
        {{ 'CART.YOUR_CART' | translate }}
      </span>

      <h1 class="cart-title">
        {{ 'CART.TITLE' | translate }}
      </h1>

    </div>


    <div class="cart-count">

      {{ cartItems.length }}

      <span>
        {{ 'CART.PRODUCTS' | translate }}
      </span>

    </div>

  </div>


  <!-- =====================================================
       CART
       ===================================================== -->

  <div
    class="cart-content"
    *ngIf="cartItems.length > 0; else emptyCart"
  >


    <!-- ===================================================
         PRODUCTS
         =================================================== -->

    <div class="cart-items">


      <div
        *ngFor="let item of cartItems"
        class="cart-item"
      >


        <!-- IMAGE -->

        <div class="product-image">

          <img
            [src]="getImageUrl(item.product.imageUrl)"
            [alt]="getProductName(item.product)"
          />

        </div>


        <!-- PRODUCT INFORMATION -->

        <div class="product-info">


          <!-- BRAND -->

          <span class="product-brand">

            {{ getBrandName(item.product) }}

          </span>


          <!-- NAME -->

          <h2 class="product-name">

            {{ getProductName(item.product) }}

          </h2>


          <!-- CATEGORY / SUBCATEGORY -->

          <div class="product-category">

            <span>

              {{ getCategoryName(item.product) }}

            </span>

            <span class="separator">
              /
            </span>

            <span>

              {{ getSubCategoryName(item.product) }}

            </span>

          </div>


        </div>


        <!-- PRICE -->

        <div class="price-section">


          <!-- DISCOUNTED -->

          <ng-container
            *ngIf="
              getDiscountPercentage(item.product) > 0;
              else normalPrice
            "
          >

            <div class="new-price">

              {{ getNewPrice(item.product) | number:'1.0-2' }}

              <span>
                {{ 'COMMON.EGP' | translate }}
              </span>

            </div>


            <div class="old-price">

              {{ getOldPrice(item.product) | number:'1.0-2' }}

              <span>
                {{ 'COMMON.EGP' | translate }}
              </span>

            </div>


            <div class="discount">

              -{{ getDiscountPercentage(item.product) }}%

            </div>

          </ng-container>


          <!-- NO DISCOUNT -->

          <ng-template #normalPrice>

            <div class="new-price">

              {{ getOldPrice(item.product) | number:'1.0-2' }}

              <span>
                {{ 'COMMON.EGP' | translate }}
              </span>

            </div>

          </ng-template>

        </div>


        <!-- QUANTITY -->

        <div class="quantity-section">

          <span class="quantity-label">
            {{ 'CART.QUANTITY' | translate }}
          </span>


          <div class="quantity-control">


            <button
              type="button"
              class="quantity-btn"

              (click)="updateQuantity(
                item.product.id,
                item.quantity - 1,
                item.product.stockQuantity
              )"

              [disabled]="item.quantity <= 1"
            >

              −

            </button>


            <input
              type="number"

              [(ngModel)]="item.quantity"

              (change)="updateQuantity(
                item.product.id,
                item.quantity,
                item.product.stockQuantity
              )"

              min="1"
[max]="item.product.stockQuantity"
              class="quantity-input"
            />


            <button
              type="button"
              class="quantity-btn"

              (click)="updateQuantity(
                item.product.id,
                item.quantity + 1,
                item.product.stockQuantity
              )"
            >

              +

            </button>

          </div>

        </div>


        <!-- SUBTOTAL -->

        <div class="subtotal-section">

          <span class="subtotal-label">

            {{ 'CART.SUBTOTAL' | translate }}

          </span>


          <strong class="subtotal">

            {{
              getItemSubtotal(item)
              | number:'1.0-2'
            }}

            <span>
              {{ 'COMMON.EGP' | translate }}
            </span>

          </strong>

        </div>


        <!-- DELETE -->

        <button
          type="button"
          class="remove-btn"

          (click)="removeFromCart(item.product.id)"

          [attr.aria-label]="
            'CART.REMOVE_PRODUCT' | translate
          "
        >

          <mat-icon>
            delete_outline
          </mat-icon>

        </button>


      </div>

    </div>


    <!-- ===================================================
         SUMMARY
         =================================================== -->

    <div class="cart-summary">


      <!-- TOTAL -->

      <div class="summary-total">

        <span>
          {{ 'CART.TOTAL' | translate }}
        </span>


        <strong>

          {{ getCartTotal() | number:'1.0-2' }}

          <small>
            {{ 'COMMON.EGP' | translate }}
          </small>

        </strong>

      </div>


      <!-- ACTIONS -->

      <div class="cart-actions">


        <!-- CONTINUE SHOPPING -->

        <button
          type="button"
          class="continue-shopping"
          (click)="back()"
        >

          <mat-icon>
            arrow_back
          </mat-icon>


          <span>
            {{ 'CART.CONTINUE_SHOPPING' | translate }}
          </span>

        </button>


        <!-- PURCHASE -->

        <div class="purchase-actions">


          <!-- CHECKOUT -->

          <button
           
            type="button"
            class="checkout-btn"
            (click)="goToCheckout()"
          >

            <mat-icon>
              shopping_bag
            </mat-icon>

            <span>
              {{ 'CHECKOUT.TITLE' | translate }}
            </span>

          </button>


          <!-- CLEAR -->

          <button
            mat-button
            type="button"
            class="clear-btn"
            (click)="clearCart()"
          >

            <mat-icon>
              delete_outline
            </mat-icon>

            <span>
              {{ 'CART.CLEAR_CART' | translate }}
            </span>

          </button>

        </div>

      </div>

    </div>

  </div>


  <!-- =====================================================
       EMPTY CART
       ===================================================== -->

  <ng-template #emptyCart>

    <div class="empty-cart">


      <div class="empty-icon">

        <mat-icon>
          shopping_bag
        </mat-icon>

      </div>


      <h2>
        {{ 'CART.EMPTY' | translate }}
      </h2>


      <p class="empty-message">

        {{ 'CART.EMPTY_MESSAGE' | translate }}

      </p>


      <button
        type="button"
        class="continue-shopping empty-shopping"
        (click)="back()"
      >

        <mat-icon>
          shopping_bag
        </mat-icon>

        {{ 'CART.CONTINUE_SHOPPING' | translate }}

      </button>


    </div>

  </ng-template>


</main>